export const SET_REFERENTIAL_TAGS = "SET_REFERENTIAL_TAGS";
export const SET_REFERENTIAL_COUNTRIES = "SET_REFERENTIAL_COUNTRIES";
export const SET_REFERENTIAL_USERCATEGORIES = "SET_REFERENTIAL_USERCATEGORIES";
export const SET_REFERENTIAL_BRANDS = "SET_REFERENTIAL_BRANDS";
export const SET_REFERENTIAL_RETAILERS = "SET_REFERENTIAL_RETAILERS";
export const SET_REFERENTIAL_EVENT_TYPES = "SET_REFERENTIAL_EVENT_TYPES";
